import { Anchor, Flex, Stack, Text } from '@vtex/admin-ui'
import { Checkbox, FormState, useWatch } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { NumberInput } from '../../../../../../NumberInput'
import { messages } from '../../messages'
import styles from '../style.css'

type Props = {
  form: FormState
  className?: string
}

const FIELD_NAME = 'group'
const MIN_VALUE = 1
enum Field {
  VALUE = `${FIELD_NAME}.value`,
  CHECKED = `${FIELD_NAME}.checked`,
}

export function Group(props: Props) {
  const { form, className = '' } = props

  const { $t } = useIntl()

  const { checked, value } = useWatch({ form, name: FIELD_NAME })

  useEffect(() => {
    if (!checked) {
      form.resetField(FIELD_NAME)
      form.setValue(Field.VALUE, undefined)
    } else {
      form.setValue(Field.VALUE, MIN_VALUE)
    }
  }, [checked, form])

  return (
    <div className={className}>
      <Checkbox
        name={Field.CHECKED}
        state={form}
        label={$t(messages.editor.group.title)}
        helpText={$t(messages.editor.group.subtitle, {
          a: (content: any) => (
            <Anchor
              target="_blank"
              href={$t(messages.editor.group.moreInformation)}
            >
              {content}
            </Anchor>
          ),
        })}
      />

      {checked && (
        <Stack fluid className={styles.checkboxContent}>
          <Flex align="baseline" className={styles.numberBox}>
            <NumberInput
              name={Field.VALUE}
              state={form}
              min={MIN_VALUE}
              fractionDigits={0}
              aria-label={$t(messages.editor.group.aria)}
            />

            <Text tone="secondary">
              {$t(messages.editor.group.coupons, { value })}
            </Text>
          </Flex>
          <Text variant="detail">
            {$t(messages.editor.group.limit, {
              limit: LIMITS.MAX_COUPONS_GROUP,
            })}
          </Text>
        </Stack>
      )}
    </div>
  )
}
